<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<script setup lang="ts">
import type { PropType } from 'vue'

interface CButtonProps {
  color?: 'primary' | 'secondary' | 'danger' | 'none'
  size?: 'x-small' | 'small' | 'large' | '' | 'x-large'
  rounded?: string | number | boolean
  variant?: 'elevated' | 'flat' | 'tonal' | 'outlined' | 'text' | 'plain'
  disabled?: boolean
  loading?: boolean
  label?: string
}

const props = defineProps({
  color: {
    type: String as PropType<CButtonProps['color']>,
    default: 'primary',
  },
  size: {
    type: String as PropType<CButtonProps['size']>,
    default: 'large',
    validator: (value: string): boolean =>
      ['x-small', 'small', '', 'large', 'x-large'].includes(value),
  },
  rounded: {
    type: String as PropType<CButtonProps['rounded']>,
    default: 'pill',
    validator: (value: string): boolean =>
      [0, 'xs', 'sm', true, 'lg', 'xl', 'pill', 'circle', 'shaped'].includes(value),
  },
  variant: {
    type: String as PropType<CButtonProps['variant']>,
    default: 'flat',
    validator: (value: string): boolean =>
      ['elevated', 'flat', 'tonal', 'outlined', 'text', 'plain'].includes(value),
  },
  type: {
    type: String,
    default: 'button',
  },
  label: {
    type: String,
    default: 'Botton',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  prependIcon: {
    type: String,
    default: '',
  },
  class: {
    type: String,
    default: '',
  },
  block: {
    type: Boolean,
    default: true,
  },
})

const emits = defineEmits({
  click: (event: MouseEvent) => true,
})
</script>

<template>
  <v-btn
    :loading="props.loading"
    style="text-transform: none"
    :class="props.class"
    :variant="props.variant"
    :size="props.size"
    :color="props.color"
    :rounded="props.rounded"
    :disabled="props.disabled"
    :text="props.label"
    :type="props.type"
    :block="props.block"
    :prepend-icon="props.prependIcon"
    @click="emits('click', $event)"
  >
  </v-btn>
</template>
